import {
  Col,
  Container,
  FormGroup,
  FormLabel,
  Row,
  Toast,
} from "react-bootstrap";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import contact from "../../../assets/images/c1.png";
import msg from "../../../assets/images/c2.png";
import address from "../../../assets/images/c3.png";
import { RotatingLines } from "react-loader-spinner";
import { MultiSelect } from "react-multi-select-component";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import map from "../../../assets/images/map.png";
import LandingPageLayout from "../../../components/landingPageLayout";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { InspectorSchema } from "../../../validations/validation";
import moment from "moment";
import { inspectorForm } from "../../../services/contact.services";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import one from "../../../assets/images/in1.png";

import two from "../../../assets/images/in2.png";
import three from "../../../assets/images/in3.png";
import four from "../../../assets/images/in4.png";
import five from "../../../assets/images/in5.png";
import styles from "../inspectorContactus/inspectorContact.module.scss";
const InspectorContact = () => {
  const [loading, setLoading] = useState(false);
  const [num, setNum] = useState(0);
  const [length, setLength] = useState(0);
  const [code, setCode] = useState("");
  const [blur, setBlur] = useState(false);
  const [formattedTime, setFormattedTime] = useState("");
  const [error, setError] = useState("");
  const [select, SetSelect] = useState([]);

  const initialValuesNew = {
    name: "",
    email: "",
    phone: "",
    timeOfCall: "",
  };

  const data = [
    { label: "Fire", value: 0 },
    { label: "Electrical", value: 1 },
    {
      label: "Building",
      value: 2,
    },
    {
      label: "Engineering",
      value: 3,
    },
    {
      label: "Plumbing",
      value: 4,
    },
  ];
  const formik = useFormik({
    initialValues: initialValuesNew,
    validationSchema: InspectorSchema(
      num,
      length
      // formik.values.phone !== ""
    ),
    onSubmit: async (values: any) => {
      try {
        if (select.length === 0 || (length > 1 && length < 11)) {
        } else {
          setLoading(true);

          let license = select.map((item: any) => item.label).join(",");

          const response: any = await inspectorForm({
            ...values,
            phone:
              values.phone === "1" || values.phone === ""
                ? undefined
                : `+${code} ${values.phone.substring(num)}`,
            type: "inspector",
            typeOfLicense: license,
          });

          if (
            response?.data?.status === 201 ||
            response?.data?.status === 200
          ) {
            SetSelect([]);
            // formik.setFieldValue("timeOfCall", "");
            toast.success(response?.data?.message);
            formik.setFieldError("phone", "");
            formik.resetForm();
            setLoading(false);
            formik.setFieldValue("phone", code);
          } else {
            toast.error("error");
          }
        }
        setLoading(false);
      } catch (e: any) {
        toast.error("error");
        setLoading(false);
      }
    },
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LandingPageLayout>
      <>
        <div className={styles.aboutUsWrapper}>
          <div className={styles.aboutUsContent}>
            <div className={styles.aboutUsHeader}>
              <h1>Work with us as an inspector</h1>
            </div>
          </div>
        </div>

        <Container>
          <div className={styles.head}>
            <p className={styles.main_p}>
              Are You A Licensed Construction Code Inspector seeking a rewarding
              opportunity?
            </p>
            <p className={styles.subheading}>
              We'd love to connect with you! Here's why working with us is a
              game-changer.
            </p>
            <div className={styles.four_Wrapper}>
              <Row>
                <Col sm={12} md={12} lg={6}>
                  <div className={styles.main_cardOne}>
                    <div className={styles.main_img}>
                      <img src={one} />
                    </div>
                    <div className={styles.text}>
                      <p>Flexible Schedule:</p>
                      <span>
                        Enjoy the freedom to work on your own schedule. Pick
                        timings that work for you and whether you want to work
                        full time or half time. Choose as per your availability.
                        Get more control over your business.
                      </span>
                    </div>
                  </div>
                </Col>
                <Col
                  className="d-flex align-items-center justify-content-center"
                  sm={12}
                  md={12}
                  lg={6}
                >
                  {" "}
                  <div className={styles.main_card}>
                    <div className={styles.main_img}>
                      <img src={two} />
                    </div>
                    <div className={styles.text}>
                      <p>Maximize Earning Potential:</p>
                      <span>
                        Unlock the potential to maximize your earnings up to
                        three times more than conventional opportunities. Your
                        expertise deserves recognition, and we ensure that your
                        efforts are duly rewarded.
                      </span>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={12} lg={6}>
                  {" "}
                  <div className={styles.main_cardOne}>
                    <div className={styles.main_img}>
                      <img src={three} />
                    </div>
                    <div className={styles.text}>
                      <p>Effortless Digital Payments:</p>
                      <span>
                        We provide hassle free payments. Our seamless digital
                        payment system ensures that you receive your earnings
                        effortlessly, on time and securely.
                      </span>
                    </div>
                  </div>
                </Col>
                <Col
                  className="d-flex align-items-center justify-content-center"
                  sm={12}
                  md={12}
                  lg={6}
                >
                  {" "}
                  <div className={styles.main_card}>
                    <div className={styles.main_img}>
                      <img src={four} />
                    </div>
                    <div className={styles.text}>
                      <p>User-Friendly Interface:</p>
                      <span>
                        Navigate your assignments with ease on your phone
                        through our simple and user- friendly interface. We
                        prioritize a hassle-free experience, allowing you to
                        focus on what you do best—inspections.
                      </span>
                    </div>
                  </div>
                </Col>{" "}
                <div className={styles.cardonewraper}>
                  {" "}
                  <div className={styles.main_cardOne1}>
                    <div className={styles.main_img}>
                      <img src={five} />
                    </div>
                    <div className={styles.text}>
                      <p>On-Call Support:</p>
                      <span>
                        Never feel alone in your journey with us. Our dedicated
                        on-phone support team is available to assist you
                        whenever you have questions. Your success is our
                        priority.
                      </span>
                    </div>
                  </div>
                </div>
              </Row>
            </div>
          </div>
          <div style={{ marginBottom: "80px" }}>
            <Row className="m-3 mb-5">
              <Col md={12} lg={6}>
                <div className={styles.secondSection}>
                  <h2>Get in touch with Us</h2>
                </div>
                <form
                  onSubmit={(e: any) => {
                    e.preventDefault();
                    if (select.length === 0) {
                      setError("This is required");
                    }
                    formik.handleSubmit();
                  }}
                >
                  <div className={styles.input_contact}>
                    <Form.Group className={styles.input_}>
                      <Form.Label>
                        Name<span className={styles.asterisk}>*</span>
                      </Form.Label>
                      <Form.Control
                        className="formall"
                        type="text"
                        placeholder="Enter your name"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        isInvalid={!!formik.errors.name && formik.touched.name}
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className={styles.input_new}>
                      <Form.Label>
                        Type of license
                        <span className={styles.asterisk}>*</span>
                      </Form.Label>
                      <MultiSelect
                        options={data}
                        // isOpen
                        labelledBy="Select"
                        onChange={(data: any) => {
                          setError("");

                          SetSelect(data);
                        }}
                        value={select}
                      />

                      {/* <Form.Control
                        type="text"
                        placeholder="Type of license"
                        name="typeOfLicense"
                        onChange={formik.handleChange}
                        value={formik.values.typeOfLicense}
                        isInvalid={
                          !!formik.errors.typeOfLicense &&
                          formik.touched.typeOfLicense
                        }
                      ></Form.Control> */}
                      {error !== "" && (
                        <span style={{ color: "#dc3545", fontSize: "14px" }}>
                          {" "}
                          {error}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className={styles.input_}>
                      <Form.Label>
                        Email<span className={styles.asterisk}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="formall"
                        placeholder="Enter your email"
                        name="email"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        isInvalid={
                          !!formik.errors.email && formik.touched.email
                        }
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        {formik.errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className={styles.input_}>
                      <Form.Label>Phone Number</Form.Label>
                      <PhoneInput
                        country={"us"}
                        onlyCountries={["us"]}
                        onBlur={(e: any) => {
                          setBlur(true);
                        }}
                        value={formik.values.phone}
                        onChange={(value: any, data: any) => {
                          const currentCountryCode = formik.values.phone
                            ? formik.values.phone.substring(
                                0,
                                data.dialCode.length
                              )
                            : data.dialCode;

                          // Extract the phone number without the country code
                          const phoneNumber = value
                            ? value.substring(data.dialCode.length)
                            : "";

                          // Update the state with the new values
                          setCode(data.dialCode);
                          setLength(value.length);
                          setNum(data.dialCode.length);

                          // Concatenate the country code with the new phone number
                          const newPhoneNumber =
                            currentCountryCode + phoneNumber;

                          // Set the new value in the formik field
                          formik.setFieldValue("phone", newPhoneNumber);
                        }}
                        onKeyDown={(
                          event: React.KeyboardEvent<HTMLInputElement>
                        ) => {
                          const countryCode = formik.values.phone
                            ? formik.values.phone.substring(0, code.length)
                            : "";

                          // Allow editing the rest of the phone number, prevent deletion of country code
                          if (
                            event.key === "Backspace" &&
                            formik.values.phone === countryCode
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      {length > 1 && length < 11 && (
                        <span style={{ color: "#dc3545", fontSize: "14px" }}>
                          Please enter a 10-digit phone number.
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group className={styles.input_time}>
                      <Form.Label>Preferred Time of call</Form.Label>
                      <Form.Control
                        type="time"
                        name="timeOfCall"
                        className="formall"
                        step="60"
                        isInvalid={
                          !!formik.errors.timeOfCall &&
                          formik.touched.timeOfCall
                        }
                        value={formik.values.timeOfCall}
                        onChange={(e: any) => {
                          const inputTime = e.target.value;
                          // Update the formatted time state
                          setFormattedTime(
                            moment(inputTime, "HH:mm").format("hh : mm ")
                          );
                          // Update the formik value in original "HH:mm" format
                          formik.setFieldValue("timeOfCall", inputTime);
                        }}
                      />
                      <span style={{ color: "#dc3545", fontSize: "14px" }}>
                        {" "}
                        {formik.errors.timeOfCall}
                      </span>
                    </Form.Group>
                  </div>
                  <div className={styles.btn}>
                    <button
                      type="submit"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Submit{" "}
                      {loading && (
                        <div>
                          {" "}
                          <RotatingLines
                            strokeColor="white"
                            strokeWidth="5"
                            animationDuration="0.75"
                            width="18"
                            visible={true}
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </Col>
              <Col lg={6}>
                {/* <div className={styles.image}>
                  <img src={map} />
                </div> */}
                <div className={styles.contact_add}>
                  {/* <div className={styles.logo}>
                    <img src={logo} />
                  </div>
                  <div className={styles.head}>
                    <span>
                      We appreciate your interest.
                      <br /> Please contact us from the <br /> options below.
                    </span>
                  </div> */}
                  <div className={styles.conatct_card}>
                    <div className={styles.card}>
                      {" "}
                      <p>Phone Number</p>
                      <span>
                        {" "}
                        <a
                          style={{ textDecoration: "none", color: "black" }}
                          href="tel:+19734494171"
                        >
                          {" "}
                          973-449-4171
                        </a>
                      </span>
                      <img src={contact} />
                    </div>
                    <div className={styles.card}>
                      {" "}
                      <p>Email Address</p>
                      <span className={styles.new_ad}>
                        sales@constructioncodeinspections.com
                      </span>
                      <img src={msg} />
                    </div>
                    <div className={styles.card}>
                      {" "}
                      <p>Address</p>
                      <span>460 Bloomfield Avenue, Montclair NJ 07006</span>
                      <img src={address} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </>
    </LandingPageLayout>
  );
};
export default InspectorContact;
